<mat-card appearance="raised" *ngIf="version" class="asset-version" [ngClass]="{ selected: selectedVersion === 'selected-' + version.version }">
  <mat-card-title class="!flex justify-between">
    <div class="w-3/5 break-words">{{ version.name }}</div>
    <div>{{ assetVersion?.createdAt | spDateFormat: { isSafe: true } }}</div></mat-card-title
  >
  <mat-card-subtitle>Version {{ version.version }}</mat-card-subtitle>
  <mat-card-actions align="end">
    <div (click)="buttonDivClick($event)" class="flex items-center gap-1">
      <button mat-flat-button class="asset-version-button" *ngIf="defaultVersion && defaultVersion === version._id.toString()" [disabled]="true">Default</button>
      <button mat-button class="asset-version-button" (click)="setAsDefault()" *ngIf="defaultVersion && defaultVersion !== version._id.toString()">Set as default</button>
      <button
        *ngIf="(AccessAsset(assetInfo) | can: 'delete') && (!defaultVersion || defaultVersion !== version._id.toString())"
        mat-icon-button
        i18n-matTooltip
        matTooltip="Delete version"
        (click)="deleteAssetVersionEvent.emit({ assetId: assetInfo._id, versionId: version._id.toString() })"
      >
        <mat-icon class="material-icons-outlined text-xl">delete</mat-icon>
      </button>
      <button
        *ngIf="assetInfo && (assetInfo.expiryDate | dateNotExpired) && (AccessAsset(assetInfo) | can: 'download')"
        mat-icon-button
        i18n-matTooltip
        matTooltip="Download version"
        (click)="this.assetCommonService.downloadAssetVersion(assetInfo, version.name, version.version, 'Library')"
      >
        <mat-icon class="material-icons-outlined text-xl">file_download</mat-icon>
      </button>
      <button *ngIf="showNewExpandButton" mat-icon-button i18n-matTooltip matTooltip="Expand asset" (click)="this.assetFullScreen.openAsset(assetInfo, version.version)">
        <mat-icon class="material-icons-outlined text-xl">open_in_full</mat-icon>
      </button>
      <button *ngIf="showNewTabButton" mat-icon-button [disabled]="disableNewTabButton" i18n-matTooltip matTooltip="Open in new tab" (click)="openInTab(assetInfo, version.version)">
        <mat-icon class="material-icons-outlined text-xl">launch</mat-icon>
      </button>
    </div>
  </mat-card-actions>
</mat-card>
